const car = "/static/media/smartcar.c23af6e1be7985dd47fd.jpg";
const cyber = "/static/media/cyber.9eba7e80610039f74ae9.jpg";
const led = "/static/media/leds.ec365a6f20a1b9c31b63.jpg";
const elect = "/static/media/elect.c001be2158e145c5a3a7.jpg";

export const content = [
  {
    id: 7,
    heading: "AUTOSAR MIGRATION AND INTEGRATION",
    para: "CellusTech India hold expertise in AUTOSAR Migration and Integration services.",
    bulb: car,
  },
  {
    id: 8,
    heading: "CYBER SECURITY SOLUTIONS",
    para: "We offer overall cybersecurity management with expertise in ISO 26262 Functional Safety and ISO 21434 Cybersecurity.",
    bulb: cyber,
  },
  {
    id: 1,
    heading: "Complete Lighting Solution (LED and smart LED)",
    para: "We manufacture, supply and service complete lighting solutions with energy-efficient LED technologies and varied designs.",
    bulb: led,
  },
  {
    id: 6,
    heading: "ELECTRICAL AND ELECTRONIC SERVICES",
    para: "We provide services for electrical and electronic parts and systems across multiple applications.",
    bulb: elect,
  },
];